
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/product/[code]/reviews",
      function () {
        return require("private-next-pages/catalog/product/[code]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/product/[code]/reviews"])
      });
    }
  